<template>
    <div class="search-result">
        <searchCondition/>
        <searchResult/>
        <shopping/>
    </div>
</template>

<script>
import searchCondition from './components/searchCondition'
import searchResult from './components/searchResult'
import shopping from './components/shopping'

export default {
  components: {
    searchCondition, searchResult, shopping
  }
}
</script>
